<div class="version-entity-association-dialog">
  <div class="version-entity-association-dialog__header">
    <h2 class="version-entity-association-dialog__title">{{ dialogTitle }}</h2>
    <button type="button" mat-icon-button (click)="closeDialog()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="version-entity-association-dialog__body">
    <form [formGroup]="filtersForm" class="search-row" (ngSubmit)="runVersionCodeSearch()">
      <div class="search-row__input-wrap">
        <input
          class="search-row__input"
          formControlName="search"
          type="text"
          placeholder="Search" />
        <button
          type="button"
          class="search-row__clear"
          *ngIf="filtersForm.controls.search.value"
          aria-label="Clear search"
          (click)="clearVersionCodeSearch()">
          &#10005;
        </button>
      </div>
    </form>

    <app-version-entity-association-attribute-search
      [eventId]="data.eventId"
      [entityType]="data.entityType"
      [versionCodeSearch]="filtersForm.controls.search.value ?? ''"
      [selectedVersionNames]="selectedVersionNames"
      [includePartialMatches]="includePartialMatches"
      (filtersChange)="onAttributeFiltersChange($event)"
      (selectedVersionNamesChange)="onSelectedVersionNamesChange($event)"
      (includePartialMatchesChange)="onIncludePartialMatchesChange($event)"
      (searchResultsChange)="onSearchResultsChange($event)">
    </app-version-entity-association-attribute-search>
  </div>

  <div class="version-entity-association-dialog__footer">
    <span class="version-entity-association-dialog__selection-summary">
      <ng-container *ngIf="selectedCount > 0">
        <strong>{{ selectedCount }}</strong>
        <span>version{{ selectedCount === 1 ? '' : 's' }} selected</span>
        <span class="version-entity-association-dialog__store-total" *ngIf="hasAttributeFilters && selectedStoreTotal > 0">
          ({{ selectedStoreTotal }} stores total)
        </span>
      </ng-container>
    </span>
    <div class="version-entity-association-dialog__actions">
      <button type="button" class="btn btn-outline btn-sm" (click)="closeDialog()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        [disabled]="selectedCount === 0"
        (click)="addVersions()">
        {{ addButtonLabel }}
      </button>
    </div>
  </div>
</div>
